import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';

import { globalStore } from "~/stores/global";
import { ROUTES } from '~/const-files/const';
import { savedStore } from "~/stores/saved";
import { getClassName, getDataContentLink, getDataLink, getGalleryLink } from "~/utils/utils";
import { clearEventsData, getLatestGalleryYearFolder, hasGalleryNews } from "~/providers/events";
import MenuItem from "../MenuItem";
import { TService } from "~/interfaces";
import { myUseState } from "~/hooks/myUseState";
import { setUserData } from "~/providers/user";

import "./style.less";

interface IState {
	showMenu: boolean;
}

interface IMenu {
	mobileVersion: boolean;
	service?: TService;
	onClick?: () => void;
}

export default function Menu({
	mobileVersion = false,
	service = "makuderovi",
	onClick = () => {},
}: IMenu) {
	const navigate = useNavigate();
	const visitData = savedStore(savedState => savedState.saved.visitData);
	const global = globalStore(globalState => globalState.global);
	const { state, toggleState, updateState } = myUseState<IState>({
		showMenu: false,
	});
	const latestYear = getLatestGalleryYearFolder();
	const overviewLink = latestYear ? getDataLink(latestYear.folder) : "";
	const news = hasGalleryNews(visitData);

	function getNewsItem(caption: string) {
		return caption
			? <>
				<span className="menu__listItemSeparator"></span>
				<span className="menu__listNewItems">{ caption }</span>
			</>
			: null;
	}

	async function logout() {
		await setUserData(null, true);
		clearEventsData();
		navigate(ROUTES.LOGIN);
		onClick();
	}

	function sendOnClick() {
		updateState({
			showMenu: false,
		});
		onClick();
	}

	const restContent = <>
		{ global.loginData && <>
			<MenuItem link={ROUTES.SEARCH} title="Hledání" onClick={sendOnClick} />
		</> }
		{ (global.loginData && service === "makuderovi") && <>
			<MenuItem link={ROUTES.FAMILY_TREE} title="Rodokmen" onClick={sendOnClick} />
			<MenuItem link={ROUTES.UPLOAD} title="Nahrávání" onClick={sendOnClick} />
			<MenuItem link={ROUTES.UPLOADED_FILES} title="Nahrané soubory" onClick={sendOnClick} />
			<MenuItem link={getDataContentLink()} title="Údaje" onClick={sendOnClick} />
			<MenuItem link={ROUTES.LINKS} title="Další stránky" onClick={sendOnClick} />
		</> }
		{ global.loginData && <a href="#" onClick={logout}>
			<li className="menu__list__item">
				<span className="menu__listItemTitle">Odhlásit</span>
			</li>
		</a> }
		{ !global.loginData && <>
			<MenuItem link={ROUTES.LOGIN} title="Přihlásit" onClick={sendOnClick} />
		</> }
	</>;

	useEffect(() => {
		/* eslint-disable no-magic-numbers */
		if (!state.showMenu) {
			return () => {};
		}

		function docOnClick() {
			updateState({
				showMenu: false,
			});
		}

		setTimeout(() => {
			document.addEventListener("click", docOnClick);
		}, 100);

		return () => {
			document.removeEventListener("click", docOnClick);
		};
	}, [state.showMenu]);

	return <div className={getClassName(["menu", service === "makuderovi" ? "" : `menu-${service}`])}>
		<span style={{ display: "flex", width: "64px" }}></span>
		<ul className="menu__list">
			<MenuItem link={ROUTES.ROOT} title="Hlavní stránka" onClick={sendOnClick} />
			{ global.loginData && <>
				<MenuItem link={overviewLink} title="Galerie" onClick={sendOnClick} activeLink={overviewLink}>
					{ getNewsItem(news ? "Nový obsah" : "") }
				</MenuItem>
				<MenuItem link={ROUTES.CALENDAR} title="Kalendář" onClick={sendOnClick} activeLink={getGalleryLink("")} />
				<MenuItem link={ROUTES.IN_THIS_DAY} title="V tento den" onClick={sendOnClick} />
			</> }
			{ mobileVersion && restContent }
		</ul>
		{ mobileVersion && <span></span> }
		{ !mobileVersion && <Button className="menu__restHamburgerBtn" onClick={() => toggleState("showMenu")}>
			<MenuIcon sx={{ fill: "#000" }} />
		</Button> }
		{ (!mobileVersion && state.showMenu) && <div className="menu__rest">
			{ restContent }
		</div> }
	</div>;
}
